export default {
  system_pop_modal(args) {
    let [
      title,
      url,
      size,
      saveName,
      otherSet,
      footerAlign,
      isTopOpen,
    ] = args.params;
    let width, height;
    if (size) {
      [width, height] = size.split(",");
    } else {
      [width, height] = ["80%", "500px"];
    }

    otherSet = _.isObject(otherSet) ? otherSet : {};

    if (footerAlign !== "left" && footerAlign !== "center") {
      footerAlign = "right";
    }

    if (url) {
      this.$openDialog({
        title: title || "",
        width: width,
        height: height,
        footerAlign: footerAlign,
        isTopOpen: isTopOpen,
        params: {
          path: url,
        },
        btns: [
          {
            text: "确定",
            handler: async (res) => {
              const _name = saveName || "system-dialog-save";
              const data = await res.yes();
              args.owner.$dispatch(_name, data);
              if (!data) {
                return false;
              }
            },
          },
          {
            text: "取消",
          },
        ],
        ...otherSet,
      });
    }
  },
  system_pop_frame(args) {
    let [
      title,
      url,
      size,
      saveName,
      otherSet,
      footerAlign,
      isTopOpen,
    ] = args.params;
    let width, height;
    if (size) {
      [width, height] = size.split(",");
    } else {
      [width, height] = ["80%", "500px"];
    }

    otherSet = _.isObject(otherSet) ? otherSet : {};

    if (footerAlign !== "left" && footerAlign !== "center") {
      footerAlign = "right";
    }

    if (url) {
      this.$openDialog({
        title: title || "",
        width: width,
        height: height,
        footerAlign: footerAlign,
        isTopOpen: isTopOpen,
        content: "DsfDialogIframe",
        params: {
          rmiframeUrl: url,
        },
        btns: [
          {
            text: "确定",
            handler: () => {
              const _name = saveName || "system-dialog-save";
              args.owner.$dispatch(_name);
            },
          },
          {
            text: "取消",
          },
        ],
        ...otherSet,
      });
    }
  },
  //打开新窗口
  system_open_window(args) {
    let url = args.params[0];
    let name = args.params[1];
    if (url) {
      // 客户环境
      if (location.href.indexOf("://10.203.") > 0) {
        url = url.replace(/:\/\/[\d\w.:]*\//, "://10.203.132.246:8088/");
      }
      args._self.$openWindow({
        url,
        name,
      });
    }
  },
  system_empty() {},
  statistics_cloud_user_import(args) {
    let datagrid = args.owner;
    let importOptions = datagrid.importOptions;
    let [
      tableName,
      sheetIndex,
      rowIndex,
      columnIndex,
      callback,
      exInfo,
      pageInfo,
    ] = args.params;
    // if (!tableName) {
    //   return dsf.layer.message("预导入按钮tableName未配置！", false);
    // }
    let that = this;
    $('<input type="file"></input>')
      .on("change", function (e) {
        upload(this.files[0]);
        $(this).off("change").remove();
      })
      .appendTo($(document.body))
      .click();

    function upload(file) {
      var formData = new FormData();
      formData.append("file", file); //上传一个files对象
      let queryFormData = {};
      for (const key in datagrid.queryString) {
        queryFormData[key] = datagrid.queryString[key];
      }
      var importAttr = {};
      if (tableName) importAttr.tableName = tableName;
      importAttr.code =
        datagrid.$vm.nameSpace + "." + datagrid.$vm.pageName + "." + tableName;
      if (sheetIndex) importAttr.sheetIndex = sheetIndex;
      if (rowIndex) importAttr.rowIndex = rowIndex;
      if (columnIndex) importAttr.columnIndex = columnIndex;
      if (importOptions) importAttr.rowRules = importOptions;
      if (exInfo) importAttr.exInfo = exInfo;
      if (importAttr) queryFormData["importAttr"] = JSON.stringify(importAttr);
      for (const key in queryFormData) {
        formData.append(key, queryFormData[key]);
      }

      const loading = dsf.layer.loading();
      $.ajax({
        //jQuery方法，此处可以换成其它请求方式
        url: dsf.url.getWebPath("/tjyUser/import/excel", datagrid.$baseUrl),
        dataType: "json",
        type: "post",
        data: formData,
        processData: false, //不去处理发送的数据
        contentType: false, //不去设置Content-Type请求头
        headers: { ...(dsf.getDefaultHttpHeader() || {}) },
        error: function (res) {
          dsf.layer.closeLoading(loading);
        },
        success: function (res) {
          dsf.layer.closeLoading(loading);
          showErrorTable.call(that, res);
        },
      });

      function showErrorTable(res) {
        if (!res.success) {
          return dsf.layer.message(res.message, false);
        }
        if (res.data.accomplish) {
          if (callback) {
            datagrid.$dispatch(callback, res);
          } else {
            datagrid.reloadData && datagrid.reloadData();
            dsf.layer.message("导入成功");
            args?._self?.$root?.$dialogAll?.[0]?.close();
          }
          return;
        }
        this.$openDialog({
          title: "预导入错误数据编辑",
          width: "95vw",
          height: "550px",
          content: "DsfStatsCloudUserImportPanel",
          center: true,
          params: {
            importId: res.data.importId,
            fileData: res.data.pieceList,
            servicePrefix: datagrid.$baseUrl,
            infoText: pageInfo,
            queryFormData: JSON.stringify(queryFormData),
          },
          showClose: false,
          btns: [
            {
              text: "确定",
              handler: (res) => {
                let btnLoading = res.$dialog.btnLoading;
                btnLoading(0, true);
                btnLoading(1, true);
                return res
                  .yes()
                  .then((_res) => {
                    if (callback) {
                      datagrid.$dispatch(callback, _res);
                    } else {
                      datagrid.reloadData && datagrid.reloadData();
                      dsf.layer.message("导入成功");
                    }
                    return Promise.resolve();
                  })
                  .catch((err) => {
                    return Promise.reject(err);
                  })
                  .finally(() => {
                    setTimeout(() => {
                      btnLoading(0, false);
                      btnLoading(1, false);
                    });
                  });
              },
            },
            {
              text: "取消",
              handler: () => {
                let laoding = dsf.layer.loading();
                return dsf.http
                  .post(
                    "tjyUser/import/clearImportCache",
                    {
                      importId: res.data.importId,
                    },
                    true
                  )
                  .always(() => {
                    dsf.layer.closeLoading(laoding);
                  });
              },
            },
          ],
        });
      }
    }
  },
};
